import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import AppContext from "../../../context/app/context";
import {Button, Col, Divider, Row, Select} from "antd";
import {FormProvider, useForm} from "react-hook-form";
import {getTranslations} from "../../../utils/helpers/translations";
import {execute} from "../../../utils/helpers/execute";
import styles from "../../trademark/trademark-form/style.module.scss";
import Spin from "../../general/antd/spin";
import {languages} from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import FormItem from "../../general/form-item";
import Controller from "../../form-components/controller";
import ImageUploader from "../../form-components/image-uploader";
import {MediumFor} from "../../../models/medium/enum";
import OldImage from "../../form-components/old-image";
import CategoryCampaignContext from "../../../context/category-campaign/context";
import {IUpdateCategoryCampaign} from "../../../models/category_campaign/request";
import CategoryCampaignContextProvider from "../../../context/category-campaign/provider";


const Form = () => {
    const {t} = useTranslation();
    const {details, actions, loading} = useContext(CategoryCampaignContext);
    const {id} = useParams();
    const navigate = useNavigate();
    const {direction} = useContext(AppContext);

    const Option = Select.Option;
    const methods = useForm<any>({
        defaultValues: {
            name: getTranslations(details?.translations?.name),
            note: getTranslations(details?.translations?.note),
            imageId: details?.image?.id ?? undefined,
        } as IUpdateCategoryCampaign,
    });

    const {
        handleSubmit,
        reset,
        control,
        setValue,
        formState: {errors},
    } = methods;

    useEffect(() => {
        reset({
            name: getTranslations(details?.translations?.name),
            note: getTranslations(details?.translations?.note),
            imageId: details?.image?.id ?? undefined,
        } as IUpdateCategoryCampaign);
    }, [details]);

    useEffect(() => {
        id && actions.getDetails(Number(id));
    }, [id]);

    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const onSubmit = async (data: any) => {
        await execute({
            callback: async () => {
                setLoadingSubmit(true);
                details
                    ? await actions.updateCategoryCampaign(details?.id, data)
                    : await actions.createCategoryCampaign(data);
                navigate(-1);
            },
            fallback: (error) => {
            },
            finallyCallback: () => {
                setLoadingSubmit(false);
            },
            throwException: false,
        });
    };
    return (
        <FormProvider {...methods}>
            <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
                <div>
                <span className={styles.title}>
                  {details ? t("update_categories_campaigns") : t("add_category_campaigns")}
                </span>
                    <Divider className={styles.divider}/>
                    {loading.includes("details") ? (
                        <div style={{height: "60vh"}}>
                            <Spin/>
                        </div>
                    ) : (
                        <div className={styles.children}>
                            <Row gutter={[16, 8]}>
                                {languages?.map((lang, index) => {
                                    return (
                                        <Col span={12}>
                                            <FieldBuilder
                                                key={index}
                                                name={`name[${lang?.code}]`}
                                                label={`${t("name")} (${lang?.name})`}
                                                input={{type: "text"}}
                                                rules={{required: true}}
                                            />
                                        </Col>
                                    );
                                })}
                                {languages?.map((lang, index) => {
                                    return (
                                        <Col span={12}>
                                            <FieldBuilder
                                                key={index}
                                                name={`note[${lang?.code}]`}
                                                label={`${t("note")} (${lang?.name})`}
                                                input={{type: "text-area"}}
                                                rules={{required: false}}
                                            />
                                        </Col>
                                    );
                                })}
                                <Col span={24}>
                                    <FormItem label={t("image")} required>
                                        <Controller
                                            name="imageId"
                                            rules={{
                                                required: {
                                                    value: true,
                                                    message: `${t("field_is_required_message")}`,
                                                },
                                            }}
                                            render={({field: {ref, ...field}}) => {
                                                return (
                                                    <ImageUploader
                                                        {...field}
                                                        type="DRAGGER"
                                                        onChange={(response) => {
                                                            // setfileId(response);
                                                            field.onChange(response?.id);
                                                        }}
                                                        imageFor={MediumFor.UserProfile}
                                                    />
                                                );
                                            }}
                                        />
                                    </FormItem>
                                </Col>
                                {details && <OldImage src={details?.image?.url}/>}

                            </Row>
                        </div>
                    )
                    }
                </div>
                <div>
                    <div className={styles.formFooter}>
                        <Button
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            {t("cancel")}
                        </Button>
                        <Button loading={loadingSubmit} htmlType="submit" type="primary">
                            {t("save")}
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    )
}


const CategoryCampaignForm = () => {
    return (
        <CategoryCampaignContextProvider>
            <Form/>
        </CategoryCampaignContextProvider>
    );
};
export default CategoryCampaignForm;